import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { v4 as uuid } from 'uuid';

@Component({
    selector: 'applicant-title',
    templateUrl: './dip.applicant-title.component.html',
    styleUrls: ['./dip.applicant-title.component.scss'],
    standalone: false
})
export class ApplicantTitleComponent implements OnInit {
  /**
   * UUI to identify controls when multiple deployed
   * @type {string}
   * @memberof ApplicantTitlecomponent
   */
  instanceId: string;
  /**
   * title - the array of available titles
   *
   * @type {string}
   * @memberof ApplicantTitleComponent
   *
   */
  titles: string[] = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr'];
  /**
   * Title from list
   *
   * @type {FormControl}
   * @memberof ApplicantTitleComponent
   */
  titleList: UntypedFormControl = new UntypedFormControl();
  /**
 * Form for selecting the title
 *
 * @memberof ApplicantTitleComponent
 */
  formTitle: UntypedFormGroup;

  /**
 * Title form button
 *
 * @type {FormControl}
 * @memberof ApplicantTitleComponent
 */
  titleButton: UntypedFormControl = new UntypedFormControl(null,[]);
  /**
   * Incoming title
   * @type {FormControl}
   * @memberof ApplicantTitleComponent
   */
  @Input() title: UntypedFormControl;
  /**
   * Output event emitter for title changes
   * @type {EventEmitter<string>}
   * @memberof ApplicantTitleComponent
   */
  @Output() titleChange: EventEmitter<UntypedFormControl> = new EventEmitter<UntypedFormControl>();

  /*

   */
  @Input() hasTitleNotSelected: boolean = false;
  /**
   * Constructor
   * @param fb @type {FormBuilder}
   * @memberof ApplicantTitleComponent
   */
  constructor(private fb: UntypedFormBuilder) {
    this.formTitle = fb.group({
      titleList: this.titleList,
      titleButton: this.titleButton,
    });
  }
  /**
   * Initialisation
   * @memberof ApplicantTitleComponent
   */
  ngOnInit() {
    this.instanceId = uuid();
    this.onChanges();
    this.formTitle.get('titleButton').setValue(this.title.value);
    this.formTitle.get('titleList').setValue(this.title.value);
  }
  /**
   * Handle changes to list/buttons
   * @memberof ApplicantTitleComponent
   */
  onChanges(): void {
    this.formTitle.get('titleButton').valueChanges.subscribe((val) => {
      this.hasTitleNotSelected = false;
      if (this.formTitle.get('titleList').value !== val) {
        this.formTitle.get('titleList').setValue(val);
        this.titleChange.emit(this.titleButton);
      }
    });
    this.formTitle.get('titleList').valueChanges.subscribe((val) => {
      this.hasTitleNotSelected = false;
      if (this.formTitle.get('titleButton').value !== val) {
        this.formTitle.get('titleButton').setValue(val);
        this.titleChange.emit(this.titleButton);
      }
    });
    
  }
}
